export default __webpack_public_path__ + "static/media/Raksha_Pawar.622780b3.png";